import { Injectable, Inject } from '@angular/core';
import { TbEnvironment } from 'src/app/model/environment';

@Injectable({
    providedIn: 'root'
})
export class SettingsService {
    constructor(@Inject('env') private env: TbEnvironment) {}
    getStoreApiUrl = (): string => this.env.settings.storeApiUrl;
    getGwamAppApiUrl = (): string => this.env.settings.gwamAppApiUrl;
    getMicroareaServiceProxyApiUrl = (): string => this.env.settings.proxyApiUrl;
}
